var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":require("@/assets/img/rdms.png"),"alt":"rdms轮播图"}})])
}]

export { render, staticRenderFns }